// TODO: Clean all this code!

// update jQuery unique to support all data types (http://paulirish.com/2010/duck-punching-with-jquery/)
;(function($) {
	const _old = $.unique
	$.unique = function(arr) {
		return arr.length && !!arr[0].nodeType
			? _old.apply(this, arguments)
			: $.grep(arr, (v, k) => $.inArray(v, arr) === k)
	}
})(jQuery)

// debouncing function from John Hann (http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/)
;(function($, sr) {
	const debounce = function(func, threshold, execAsap) {
		let timeout

		return function debounced() {
			let obj = this,
				args = arguments
			function delayed() {
				if (!execAsap) func.apply(obj, args)
				timeout = null
			}

			if (timeout) clearTimeout(timeout)
			else if (execAsap) func.apply(obj, args)

			timeout = setTimeout(delayed, threshold || 100)
		}
	}
	// smartresize
	jQuery.fn[sr] = function(fn) {
		return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr)
	}
})(jQuery, 'smartresize')

// Array Remove - By John Resig (MIT Licensed)
Array.prototype.remove = function(from, to) {
	const rest = this.slice((to || from) + 1 || this.length)
	this.length = from < 0 ? this.length + from : from
	return this.push.apply(this, rest)
}

/*!
 * Simple jQuery reverse plugin
 */
jQuery.fn.reverse = [].reverse

/*!
 * Remove all class names matching prefix
 */
$.fn.removeClassPrefix = function(prefix) {
	this.each((i, el) => {
		let classes = el.className.split(' ').filter((c) => {
			return c.lastIndexOf(prefix, 0) !== 0
		})
		el.className = classes.join(' ')
	})
	return this
}

/*!
 * jQuery mcNumberFormat plugin v2.1.0
 * Adds commas to numeric strings
 */
;(function($) {
	$.fn.mcNumberFormat = function() {
		return this.each(function() {
			$(this).text(
				$(this)
					.text()
					.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
			)
		})
	}
})(jQuery)

// $.blockUI.defaults.css = {};
// $.blockUI.defaults.overlayCSS = {};

/**
 * Number.prototype.format(n, x)
 *
 * @param integer n: length of decimal
 * @param integer x: length of sections
 */
Number.prototype.format = function(n, x) {
	var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')'
	return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,')
}
